var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92399 1.67691C7.92399 1.02694 8.43761 0.500036 9.07119 0.500036C9.70478 0.500036 10.2184 1.02694 10.2184 1.67691V7.82221H16.21C16.8435 7.82221 17.3572 8.34911 17.3572 8.99908C17.3572 9.64905 16.8435 10.1759 16.21 10.1759H10.2184V16.3232C10.2184 16.9731 9.70478 17.5 9.0712 17.5C8.43761 17.5 7.92399 16.9731 7.92399 16.3232V10.1759H1.93294C1.29936 10.1759 0.78574 9.64905 0.78574 8.99908C0.78574 8.34911 1.29936 7.82221 1.93294 7.82221H7.92399V1.67691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedPlusIcon);
export default __webpack_public_path__ + "static/media/rounded-plus-icon.c4a78c37d7013f3b24ba3c95744e5f8a.svg";
export { ForwardRef as ReactComponent };